import FormInputComponent from './form-input-component';

/***
 * A row in a enter-data-form that renders a label with either a form to edit the value or a
 * static representation of the currently saved value.
 */
const formInput = angular
    .module('FacilityData.EnterData.FormInput', [])
    .component('formInput', FormInputComponent)
    .name;

export default formInput;


// WEBPACK FOOTER //
// ./app/components/enter-virtual-data/form-input/form-input.js